export default __webpack_public_path__ + "static/media/cp_geo_td.180f416f.svg";